import type { ReactNode } from 'react';
import { Nav } from './Nav';
import { Footer } from './Footer';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1 px-[var(--space-gutter)] py-12 md:py-20">
        <div className="max-w-page mx-auto w-full">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
